import { useEffect } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import { navLinks } from '../../../UseNavLinks';

import useGroupNationalTeamInviteData from '../../../state/workflow/groupNationalTeamInvite/UseGroupNationalTeamInviteData';

import Constants from '@usas/ui-web/utils/Constants';

const useGroupNationalTeamInvite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { groupNationalTeamInviteState, getGroupNationalTeamInvites } = useGroupNationalTeamInviteData();

  const onGroupInviteClicked = (e, groupInvite) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(navLinks.GROUP_NATIONAL_TEAM_INVITE_APPROVALS, { state: { groupInvite, isRevisit: location.state?.isRevisit } });
  };

  useEffect(() => {
    if (groupNationalTeamInviteState.isArrayLoaded !== true) {
      if (location.state && location.state?.isRevisit === true) {
        getGroupNationalTeamInvites(true);
      }
      else {
        getGroupNationalTeamInvites(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    location,
    Constants,
    groupNationalTeamInviteState,
    onGroupInviteClicked
  };
};

export default useGroupNationalTeamInvite;